import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Button, Icon } from 'antd';
import {connect} from 'react-redux';
import {fetchContractorAdmins, fetchContractor} from '../../actions';
import PaginatedList from '../PaginatedList';

class Admins extends Component {
    componentDidMount() {
        if (!this.props.contractor.id) {
            const {contractor_id, fetchContractor} = this.props;
            return fetchContractor(contractor_id);
        }
    }
    render() {
        const {fetchContractorAdmins, admins, contractor: {id: contractorId}, match, location: {search}} = this.props;
        if (!contractorId) return null;

        const columns = [{
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <span>
                    <Link to={{
                        pathname: `${match.url}/${record.id}/edit`,
                        state: {
                            from: search || 'page=1'
                        }
                    }}>{text}</Link>
                </span>
            )
        }, {
            title: 'Job Title',
            dataIndex: 'job_title',
            key: 'job_title'
        }, {
            title: 'Email',
            dataIndex: 'email',
            key: 'email'
        }, {
            title: 'Phone Number',
            dataIndex: 'phone_number',
            key: 'phone_number'
        }, {
            title: 'Permissions',
            key: 'permissions',
            render: () => 'ALL'
        }];

        const fetch = page => {
            return fetchContractorAdmins(contractorId, page);
        };
        return (
            <div>
                <Button style={{marginBottom: 10}} type="primary">
                    <Link to={`${match.url}/new`}><Icon type="plus"/> New</Link>
                </Button>
                <PaginatedList
                    fetchData={fetch}
                    columns={columns}
                    source={admins}
                    {...this.props}
                />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    const admins = state.contractor.admins;
    return {
        contractor_id: state.me.contractor_id,
        contractor: {...state.contractor.profile},
        admins: [...admins.data],
        meta: admins.meta,
        loading: admins.isFetching,
    };
};

export default connect(mapStateToProps, {
    fetchContractorAdmins,
    fetchContractor
})(Admins);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/Admins.js